document.querySelectorAll('.lab-where-to-next__block').forEach((block) => {
  const image = block.querySelector('.lab-where-to-next__block-image');

  if (image) {
    const moveImage = (e) => {
      const rect = block.getBoundingClientRect();
      image.style.left = (e.clientX - rect.left) + 'px';
      image.style.top = (e.clientY - rect.top) + 'px';
    };

    block.addEventListener('mouseenter', moveImage);
    block.addEventListener('mousemove', moveImage);
  }

  const video = block.querySelector('.lab-where-to-next__block-video');

  if (!video) return;

  const ensureLoaded = () => {
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
    }
  };

  const playVideo = () => {
    ensureLoaded();
    video.currentTime = 0;

    if (video.readyState >= 2) {
      video.play().catch(() => {});
      return;
    }

    video.addEventListener('loadeddata', () => video.play().catch(() => {}), { once: true });
  };

  const pauseVideo = () => {
    video.pause();
    video.currentTime = 0;
  };

  block.addEventListener('mouseenter', playVideo);
  block.addEventListener('mouseleave', pauseVideo);
  block.addEventListener('focusin', playVideo);
  block.addEventListener('focusout', pauseVideo);
});
